import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Divider,
} from "@material-ui/core";
import { Link, useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  listRoot: {
    width: 280,
  },
  link: {
    textDecoration: "none",
    color: "black",
    fontSize: 15,
    fontWeight: 600,
    width: "100%",
    display: "block",
    padding: theme.spacing(1, 2),
    "&:hover": {
      color: "rgb(223, 32, 32)",
    },
  },
  active: {
    color: "rgb(223, 32, 32)",
  },
  menuIconButton: {
    padding: theme.spacing(1),
  },
}));

export const NavbarDrawer = ({
  open = false,
  onClose = () => {},
  navItems = [],
  activePathChecker,
}) => {
  const classes = useStyles();
  const location = useLocation();

  // fallback nav items if none passed
  const DEFAULT_NAV = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Blog", path: "/blog" },
    { label: "Contact Us", path: "/contact" },
    { label: "Careers", path: "/careers" },
    { label: "Refund Policy", path: "/refunds" },
    { label: "T&C", path: "/tandc" },
  ];

  const items = navItems && navItems.length ? navItems : DEFAULT_NAV;

  const isActive = (path) => {
    if (activePathChecker) return activePathChecker(path);
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <>
      {/* If consumer wants a separate toggle elsewhere they can keep MenuIcon there.
          We still export a small toggle button below in case you want to render it itself. */}
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        aria-label="Navigation drawer"
      >
        <div
          className={classes.listRoot}
          role="presentation"
          onKeyDown={(e) => {
            if (e.key === "Escape") onClose();
          }}
        >
          <List>
            {items.map((item) => (
              <ListItem
                button
                key={item.path}
                component={Link}
                to={item.path}
                onClick={onClose}
                selected={isActive(item.path)}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    style: {
                      fontWeight: 600,
                      color: isActive(item.path) ? "rgb(223,32,32)" : undefined,
                    },
                  }}
                />
              </ListItem>
            ))}
          </List>

          <Divider />

          {/* you can add contact quick links or other stuff here if needed */}
        </div>
      </Drawer>
    </>
  );
};

export default NavbarDrawer;
